import { createAsyncThunk } from "@reduxjs/toolkit";
import { ax } from "src/common/api/apiClient";
import { IApi } from "src/common/typings/app";

// get  camera stream link method
export const getCameraStreamAction = createAsyncThunk("camera/getCameraStreamAction", async () => {
  try {
    const res = await ax.get<IApi>("/get-camera-stream-link");
    if (res.data.isSuccess === true && res.data.value) return res.data.value;
    else throw new Error(res.data.error || res.statusText);
  } catch (error) {
    throw error;
  }
});
